<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        @click="$router.push({name: 'services-create'})"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="medium"
      >Tambah Layanan</vs-button>
      <vs-card>
        <div slot="header">
          <div class="vx-row m-2">
            <h3>Layanan</h3>
          </div>
        </div>
        <div slot="header">
          <div class="vx-row flex flex-col m-0  w-full">
            <div class="flex w-full ">
              <div class="flex-1 p-2">
                <div class="w-full">
                  <vs-input icon-pack="feather" icon="icon-search" placeholder="Cari Nama Layanan"
                    v-model="filterSearch" class=" w-full" />
                </div>
              </div>
              <div class="w-full p-2  md:w-1/4">
                <v-select :options="agencies" v-model="agencyId" />
              </div>
              <div class="w-full p-2  md:w-1/4">
                <v-select :options="listServiceStatus" v-model="serviceStatus" />
              </div>
              <div class="w-full p-2  md:w-1/4">
                <v-select :options="listQueueStatus" v-model="queueStatus" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col">
          <vs-table :data="services">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Layanan</vs-th>
              <vs-th>Instansi / Dinas</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Status Antrian</vs-th>
              <vs-th>Pilihan</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                <vs-td :data="tr.agency">{{ tr.initial }}</vs-td>
                <vs-td :data="tr.status">
                  <vs-chip v-if="tr.status" color="green">Aktif</vs-chip>
                  <vs-chip v-else color="warning">Tidak Aktif</vs-chip>
                </vs-td>
                <vs-td :data="tr.is_available_queue">
                  <vs-chip v-if="tr.is_available_queue == 1" color="green">Antrian Aktif</vs-chip>
                  <vs-chip v-else color="warning">Antrian Tidak Aktif</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vs-button
                      @click="$router.push({name: 'services-detail', params: {id: tr.id}})"
                      color="primary"
                      size="small"
                      class="m-1"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                    >Lihat</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import _ from "lodash";

export default {
  data() {
    return {
      services: [],
      filterSearch : '',
      agencyId: {
        value: "-",
        label: "SEMUA INSTANSI"
      },
      serviceStatus: {
        value: 1,
        label: "AKTIF"
      },
      queueStatus: {
        value: 1,
        label: "ANTRIAN AKTIF"
      },
      agencies : [],
      listQueueStatus : [
        { value: 1, label: "ANTRIAN AKTIF" },
        { value: 0,label: "ANTRIAN TIDAK AKTIF"},
      ],
      listServiceStatus : [
        { value: 1, label: "AKTIF" },
        { value: 0,label: "TIDAK AKTIF"},
      ]
    };
  },
  mounted() {
    this.getData();
  },
  components: {
    "v-select": vSelect,
    Datepicker
  },
  methods: {
    getData() {
      this.$vs.loading();
      let params = {
        is_available_queue: this.queueStatus.value,
        status: this.serviceStatus.value,
        agency_id: this.agencyId.value,
        filter_search : this.filterSearch,
      }

      this.$http
      .post("/app/secure/service/getData", params)
      .then(r => {
        this.services = r.data.data.services;
        this.agencies = r.data.data.agencies;
      })
      .catch(e => {
        this.parseError(e);
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    }
  },
  watch: {
    filterSearch: _.debounce(function (query) {
      this.getData(query);
    }, 500),
    agencyId() {
      this.getData();
    },
    serviceStatus() {
      this.getData();
    },
    queueStatus() {
      this.getData();
    }
  },
};
</script>>
